<template>
    <div>
        <section class="flex font-poppins md:flex-col">
            <div>
                <AdminDashboardNav/>
            </div>
            <section class="font-poppins w-screen p-2  md:pl-1 md:pr-1">
                <section class="mt-6">
                    <div class=" flex justify-between md:flex-col-reverse">
                        <div class="md:mt-6">
                            <GetDate/>
                            <p class="text-blue-700 font-bold text-2xl md:text-lg">CONFIGURATION</p>
                        </div>

                        <div class=" mr-10">
                            <Notification/>
                        </div>
                    </div>
                </section>
                <div class="mt-10 flex md:flex-col">
                    <div class="profile bg-gray-50 w-1/4 pl-4 pt-2  border rounded-xl h-52 md:flex md:justify-between md:border-0 md:w-full md:h-16">
                        <p @click="setSelectedTab('pricing')" :class="{active: selectedTab === 'pricing'}"  class=" cursor-pointer mt-6 border-b border-gray-200">Pricing</p>
                        <p @click="setSelectedTab('deduction')" :class="{active: selectedTab === 'deduction'}"  class="cursor-pointer mt-6 border-b border-gray-200">Deduction</p>
                        <p @click="setSelectedTab('promo-code')" :class="{active: selectedTab === 'promo-code'}"  class="cursor-pointer mt-6 border-b border-gray-200">Promo Codes</p>
                    </div>

                    <component class="md:mt-4 w-full" :is="selectedTab"></component>

                </div>
            </section>

            
        </section>
    </div>
</template>

<script>
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import NetworkError from '../ConnectionLost.vue';
import Pricing from './Pricing.vue';
import PromoCode from './PromoCode.vue';
import Deduction from './Deduction.vue';
export default {
    components : {
        GetDate,
        Notification,
        AdminDashboardNav,
        NetworkError,
        Pricing,
        PromoCode,
        Deduction
    },
    data() {
        return {
            selectedTab: 'pricing'
        };
    },

    mounted() {
        this.networkError()
    },

    methods: {
        setSelectedTab(tab) {
            this.selectedTab = tab
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            }
        } 
     }
}
</script>